// extracted by mini-css-extract-plugin
export default {"logo":"Header_logo__Ww9JH","header__section":"Header_header__section__ncI86","footnote":"Header_footnote__T0+4M","button":"Header_button__TzucY"};